import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["innerRef", "navigate", "onClick"],
  _excluded2 = ["component", "replace", "to", "innerRef"];
import { createElement, forwardRef } from 'react';
import { __RouterContext as RouterContext } from '../react-router';
import invariant from '../tiny-invariant';
import { resolveToLocation, normalizeToLocation } from './utils/locationUtils';
import { jsx as _jsx } from "react/jsx-runtime";
function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const LinkAnchor = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
      innerRef,
      navigate,
      onClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    target
  } = rest;
  return /*#__PURE__*/_jsx("a", Object.assign({}, rest, {
    ref: forwardedRef || innerRef,
    onClick: event => {
      try {
        if (onClick) onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }
      if (!event.defaultPrevented &&
      // onClick prevented default
      event.button === 0 && (
      // ignore everything but left clicks
      !target || target === '_self') &&
      // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
        event.preventDefault();
        navigate();
      }
    }
  }));
});
if (process.env.NODE_ENV !== 'production') {
  LinkAnchor.displayName = 'LinkAnchor';
}
/**
 * The public API for rendering a history-aware <a>.
 */
const Link = /*#__PURE__*/forwardRef((_ref2, forwardedRef) => {
  let {
      component = LinkAnchor,
      replace,
      to,
      innerRef
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(RouterContext.Consumer, {
    children: context => {
      invariant(context, 'You should not use <Link> outside a <Router>');
      const {
        history
      } = context;
      const location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
      const href = location ? history.createHref(location) : '';
      return /*#__PURE__*/createElement(component, Object.assign({}, rest, {
        ref: forwardedRef || innerRef,
        href,
        navigate() {
          const resolvedLocation = resolveToLocation(to, context.location);
          const method = replace ? history.replace : history.push;
          method(resolvedLocation);
        }
      }));
    }
  });
});
if (process.env.NODE_ENV !== 'production') {
  Link.displayName = 'Link';
}
export default Link;